import React, { useEffect, useState } from "react";
import { Form, message } from "antd";
import { SaveButton, InputText, InputTextArea, CancelButton, ButtonComponent, ModalComponent, trans } from "@comps/components"
import { makeRequest } from "@utils/helpers";
import { createDataReq } from "../requests";
import { Commons, Const } from "../../../constants";
import { PlusCircleOutlined } from "@ant-design/icons";
import CreateExpression from '../../formula/components/CreateExpression';

const langKey = Const["rule"].lngKey
const formName = "createRule";

const CreateRule = (props) => {
  const [loader, setLoader] = useState(false);
  const [saving, setsaving] = useState(false);
  const [childComponent, setChildComponent] = useState(false);
  const [form] = Form.useForm()
  const [expression, setExpression] = useState('');
  const [isValid, setIsValid] = useState(true)
  useEffect(() => {
    // eslint-disable-next-line
  }, []);

  const onSubmit = (data) => {
    if (expression === '' || expression === null) {
      message.error('Please enter a valid expression')
      return
    }

    setsaving(true)
    const payload = {
      payroll_rule: {
        name: data.name,
        expression: expression, company_id: localStorage.getItem('company_id') ? localStorage.getItem('company_id') : 1
      }
    };
    makeRequest(setLoader, createDataReq, payload, onSuccess, onError);
  }

  const onSuccess = (data, res) => {

    message.success(res.message);
    props.onCompleted(data.payroll_rules.data);
    props.onSuccess(data)
  }

  const onError = (err, res) => {

    setsaving(false)
    message.error(res.response.data.message);
  }

  const onCreateExpression = () => {
    const options = {
      exclude: null,
      formulas: true,
      payitems: null,
      rules: null
    }
    setChildComponent(<CreateExpression onCompleted={ onCompleted } record={ expression } isValid={ isValid } options={ options } />)
  }

  const onCompleted = (data, isValid) => {
    if (data) {
      setExpression(data)
      setIsValid(isValid)
    }

    setChildComponent(null)
  }
  //-----------------------
  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------

  const footer = [

    <SaveButton loading={ saving } form={ formName } key="create_button" htmlType="submit" />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];

  // ------------------------------------
  // Eend footer buttons array
  // ------------------------------------

  return (
    <ModalComponent top={ 20 } width={ 600 } maskClosable={ false }
      mainTitle={ trans(Commons.create) } subTitle={ trans(`${langKey}.moduleName`) }
      visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) }>
      { childComponent }
      <Form { ...formLayout } name={ formName } onFinish={ onSubmit } form={ form } >

        <Form.Item name="name" rules={ rules.name } label={ trans(Commons.name) }
          className="da-mb-16"
        >
          <InputText placeholder={ trans(`${langKey}.name`) } />
        </Form.Item>
        <Form.Item style={ { paddingRight: 35 } } name="expression" label={ trans(`${langKey}.expression`) }
          className="da-mb-16"
        >
          <InputTextArea placeholder={ trans(`${langKey}.expression`) } disabled={ true } value={ expression } /><ButtonComponent className="formula-btn" onClick={ onCreateExpression } icon={ <PlusCircleOutlined style={ { marginLeft: -7 } } /> } />
        </Form.Item>

      </Form>
    </ModalComponent>
  )
}

export default CreateRule

const rules = {
  name: [
    { required: true, message: trans(`${langKey}.name`) },
  ],
  expression: [
    { required: true, message: trans(`${langKey}.expression`) },
  ],


};

const formLayout = {
  layout: "vertical",
  labelCol: { span: 6 },
  wrapperCol: { span: 24 },
  labelAlign: "left"
}